import { Box, MenuItem, Stack, Typography } from "@mui/material"
import React from "react"

import { useNavigate } from "react-router-dom"

import { Pool } from "../../api/pools-api"
import { TokenAvatar } from "../TokenAvatar"

import { useTokenInfo } from "@/hooks/use-token-info"
import FeeDisplay from "../FeeDisplay"
import { useStore } from "@nanostores/react"
import { $poolsOverviewFull, $poolsOverviewMap } from "@/stores/pools-store"
import { PriceDisplay } from "../PriceDisplay"
import { Star, StarOutline } from "@mui/icons-material"
import MarketCapDisplay from "../MarketCapDisplay"
import { PoolWithFee } from "../PoolWithFee"

export function SearchOption(props: { pool: Pool; handleClose: () => void }) {
  const { pool, handleClose } = props
  const { id } = pool

  const overview = useStore($poolsOverviewMap)

  const poolDetails = overview ? overview[id] : undefined

  const navigate = useNavigate()

  return (
    <>
      <MenuItem
        onClick={() => {
          handleClose()
          navigate(`/pool/${id}`)
        }}
        sx={{
          padding: 1,
          border: "1px solid var(--mui-palette-divider)",
          borderRadius: 1,
          width: "100%",
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <PoolWithFee pool={pool} />
          <Stack
            direction="column"
            gap={0.5}
            sx={{ opacity: pool.status === "private" ? 0.35 : 1, width: "100%" }}
          >
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "monospace" }}>
                {pool.id}
              </Typography>
              {/* <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
                justifyContent="flex-end"
                flexGrow={1}
              >
                <StarOutline />
              </Stack> */}
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center">
              {pool.amm_status === "private" && (
                <Typography variant="caption" color="text.secondary">
                  This pool is not yet subscribed to DEXI.
                </Typography>
              )}
              {poolDetails && (
                <>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="caption">Liquidity:</Typography>
                    <PriceDisplay amount={poolDetails.liquidityUsd} />
                  </Stack>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="caption">MarketCap:</Typography>
                    <MarketCapDisplay pool={poolDetails} />
                  </Stack>
                </>
              )}
            </Stack>
          </Stack>
        </Stack>
      </MenuItem>
    </>
  )
}
